export default __webpack_public_path__ + "static/media/my-files.20064184.svg";